import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-observe-statical-evaluation',
  templateUrl: './ph-bhp-observe-statical-evaluation.component.html',
  styleUrls: ['./ph-bhp-observe-statical-evaluation.component.css']
})
export class PhBhpObserveStaticalEvaluationComponent implements OnInit {

  @Output() childData = new EventEmitter();
  translationKeys: typeof TranslationKeys = TranslationKeys;

  constructor(private router: Router) { }

  ngOnInit() {
  }
  emitData(event){
    switch(event.key){
      case 'overallCompliance': this.router.navigate(['evaluation/observe/overallCompliance']);    break;
      case 'fiveMoments': this.router.navigate(['evaluation/observe/fivemoments']);    break;
      case 'individualOverview': this.router.navigate(['evaluation/observe/individualOverview']);    break;
      case 'comments': this.router.navigate(['evaluation/observe/comments']);    break;
      case 'quota': this.router.navigate(['evaluation/observe/quota']);    break;
      case 'StatisticsBeforeAsepticProcedures': this.router.navigate(['evaluation/observe/StatisticsBeforeAsepticProcedures']);    break;
      default: this.router.navigate(['evaluation/observe/overallCompliance']);    break;

    }
  }
}
